<template>
    <div class="grid-cols-3 gap-4 py-6 mb-4 bg-white rounded-lg shadow-sm md:grid">
        <div class="col-span-1 px-6 mb-4 border-r border-gray-100 sm:mb-0">
            <h2 class="mb-6 text-xl font-semibold text-gray-800">{{ _mft('dashboard:tasks.headings.leadflow') }}</h2>

            <div class="space-y-4">
                <dashboard-task v-for="task in data.leadflow" :key="task.title" :task="task"></dashboard-task>
            </div>
        </div>
        <div class="col-span-1 px-6 mb-4 border-r border-gray-100 sm:mb-0">
            <h2 class="mb-6 text-xl font-semibold text-gray-800">{{ _mft('dashboard:tasks.headings.workflow') }}</h2>

            <div class="space-y-4">
                <dashboard-task v-for="task in data.workflow" :key="task.title" :task="task"></dashboard-task>
            </div>
        </div>
        <div class="col-span-1 px-6 mb-4 border-r border-gray-100 sm:mb-0">
            <h2 class="mb-6 text-xl font-semibold text-gray-800">{{ _mft('dashboard:tasks.headings.dealflow') }}</h2>

            <div class="space-y-4">
                <dashboard-task v-for="task in data.dealflow" :key="task.title" :task="task"></dashboard-task>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import axios from 'axios';


    const data = ref({
        leadflow: [],
        workflow: [],
        dealflow: [],
    });

    const fetchData = async () => {
        try {
            const response = await axios.get(route('boIndex.dashboardV2Tasks'));
            data.value = response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    onMounted(fetchData);
</script>

<style scoped>

</style>
